<template>

  <ContentTemplate title="Primary Email" :container-size-small="true">
    <form>
      <FormGroupSection
          v-for="(item, index) in emailFormInfos"
          :key="index"
          :form-element="item"
          v-model:input-value="form[item.input.name]"
          :validator="v$.form[item.input.name]"/>

      <div class="row" v-if="userInfo.authProvider === providerLocal">
        <div class="col-12 d-flex justify-content-end mt-2">
          <ButtonElement
              @clickOnButton="changeEmail()"
              class="btn--ms btn--accent">
            Update Email
          </ButtonElement>
        </div>
      </div>
    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {ButtonElement, ContentTemplate, FormGroupSection,} from '@shared/components';
import useVuelidate from '@vuelidate/core';
import {email, helpers, required} from '@vuelidate/validators';
import {AccountNs, CommonNs, UserNs} from "@shared/types";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {useAccountStore} from "@domains/account/stores/account.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'EmailView',
  components: {
    ButtonElement,
    ContentTemplate,
    FormGroupSection,
  },
  data() {
    return {
      providerLocal: UserNs.AuthProvider.LOCAL,
      form: {} as { [key: string]: string },
      emailFormInfos: [] as CommonNs.InputFormGroup[],
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  computed: {
    ...mapStores(useUserStore, useAccountStore, useGeneralStore),
    userInfo(): UserNs.UserInfo {
      return this.userStore.getUserInfo;
    }
  },
  mounted(): void {
    this.buildForm();
  },
  validations() {
    const mustBeNotEqual = (value: string) => this.userInfo.userName !== value
    return {
      form: {
        currentEmail: {
          required,
          email,
        },
        newEmail: {
          required,
          email,
          mustBeNotEqual: helpers.withMessage('New email cannot be the same as the current email', mustBeNotEqual),
        },
        password: {required},
      },
    };
  },
  methods: {
    buildForm(): void {
      this.form = {
        currentEmail: this.userInfo.userName,
        newEmail: '',
        password: '',
      };
      this.emailFormInfos = [] as CommonNs.InputFormGroup[];
      if (this.userInfo.authProvider === UserNs.AuthProvider.LOCAL) {
        this.emailFormInfos.push({
          label: 'Current Primary Email',
          iconType: 'fal',
          icon: 'Mail',
          input: {
            name: 'currentEmail',
            type: 'text',
            placeholder: 'Email',
            isDisable: true,
            isLocked: true,
          },
        });

        this.emailFormInfos.push({
          label: 'New Primary Email',
          iconType: 'fal',
          icon: 'Mail',
          input: {
            name: 'newEmail',
            type: 'text',
            placeholder: 'New Primary Email',
          }
        });

        this.emailFormInfos.push({
          label: 'Password',
          iconType: 'fal',
          icon: 'Lock',
          input: {
            name: 'password',
            type: 'password',
            placeholder: 'Password',
          }
        });
      } else if (this.userInfo.authProvider === UserNs.AuthProvider.GOOGLE) {
        this.emailFormInfos.push({
          label: 'Connected with Google',
          svgClass: 'google',
          input: {
            name: 'currentEmail',
            type: 'text',
            placeholder: 'Email',
            isDisable: true,
            isLocked: true,
          }
        });
      } else if (this.userInfo.authProvider === UserNs.AuthProvider.LINKEDIN) {
        this.emailFormInfos.push({
          label: 'Connected with Linkedin',
          svgClass: 'linkedin',
          input: {
            name: 'currentEmail',
            type: 'text',
            placeholder: 'Email',
            isDisable: true,
            isLocked: true,
          }
        });
      }
    },
    changeEmail(): void {
      this.v$.$touch();
      // @ts-ignore
      if (this.v$.form.$invalid) {
        return;
      }

      const payload = {
        newEmail: this.form.newEmail,
        password: this.form.password,
      } as AccountNs.ChangePrimaryEmailRequest;

      this.accountStore.changePrimaryEmail(payload).then(() => {
        toast.success(`An email has been sent to ${this.form.newEmail} to confirm the email address`);
      })
    },
  },
});
</script>
